import {
  GET_MEMBERS_URL,
  ORGANIZATIONS_URL,
  GET_ROLES_URL,
  ORGANIZATION_DETAILS_URL,
} from "@/config/apiEndpoints";
import convertDate from "@/utils/convertDateToStandard";
import apiRequest from "@/utils/apiRequest";
export const state = {
  organizations: [],
  selectedOrgDetails: null,
  members: [],
  loading: false,
  selectedMember: null,
  showMemberModal: false,
  roles: [],
  status: [],
};
export const getters = {
  organizations: (state) => state.organizations,
  selectedOrgDetails: (state) => state.selectedOrgDetails,
  members: (state) => state.members,
  loading: (state) => state.loading,
  selectedMember: (state) => state.selectedMember,
  roles: (state) => state.roles,
  status: (state) => state.status,
  showMemberModal: (state) => state.showMemberModal,
};

export const mutations = {
  STORE_MEMBERS(state) {
    state.members = [];
    state.loading = true;
  },
  STORE_MEMBERS_SUCCESS(state, members) {
    state.members = [...members];
    state.loading = false;
  },
  STORE_MEMBERS_FAILED(state) {
    state.members = [];
    state.loading = false;
  },
  STORE_ORGANIZATIONS(state) {
    state.organizations = [];
    state.loading = true;
  },
  STORE_ORGANIZATIONS_SUCCESS(state, organizations) {
    state.organizations = [...organizations];
    state.loading = false;
  },
  STORE_ORGANIZATIONS_FAILED(state) {
    state.organizations = [];
    state.loading = false;
  },
  STORE_ORGANIZATION_DETAILS(state) {
    state.selectedOrgDetails = {};
    state.loading = true;
  },
  STORE_ORGANIZATION_DETAILS_SUCCESS(state, selectedOrgDetails) {
    state.selectedOrgDetails = { ...selectedOrgDetails };
    state.loading = false;
  },
  STORE_ORGANIZATION_DETAILS_FAILED(state) {
    state.selectedOrgDetails = {};
    state.loading = false;
  },
  STORE_ROLES(state) {
    state.roles = [];
    state.loading = true;
  },
  STORE_ROLES_SUCCESS(state, roles) {
    state.roles = [...roles];
    state.loading = false;
  },
  STORE_ROLES_FAILED(state) {
    state.roles = [];
    state.loading = false;
  },
  STORE_ALL_STATUS(state) {
    state.status = [];
    state.loading = true;
  },
  STORE_ALL_STATUS_SUCCESS(state, status) {
    state.status = [...status];
    state.loading = false;
  },
  STORE_ALL_STATUS_FAILED(state) {
    state.status = [];
    state.loading = false;
  },
  SELECT_MEMBER(state, selectedMember) {
    state.selectedMember = selectedMember;
  },
  DELETE_MEMBER(state, memberId) {
    state.members = state.members.filter((x) => x.member_id !== memberId);
  },
  SHOW_MEMBER_MODAL(state, show) {
    state.showMemberModal = show;
  },
};

export const actions = {
  fetchOrganizations({ commit }) {
    commit("STORE_ORGANIZATIONS");
    return new Promise((resolve, reject) => {
      apiRequest({
        url: ORGANIZATIONS_URL,
        method: "GET",
        params: { type: "c" },
      })
        .then((res) => {
          commit("STORE_ORGANIZATIONS_SUCCESS", res.data);
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  fetchOrganizationDetails({ commit }, id) {
    commit("STORE_ORGANIZATION_DETAILS");
    return new Promise((resolve, reject) => {
      apiRequest({
        url: ORGANIZATION_DETAILS_URL,
        method: "GET",
        params: {
          type: "o",
          org_id: id,
        },
      })
        .then((res) => {
          commit("STORE_ORGANIZATION_DETAILS_SUCCESS", res.data);
          resolve(res.data);
        })
        .catch((err) => {
          commit("STORE_ORGANIZATION_DETAILS_FAILED");
          reject(err);
        });
    });
  },

  fetchMembers({ commit }, params) {
    commit("STORE_MEMBERS");
    return new Promise((resolve, reject) => {
      apiRequest({
        url: GET_MEMBERS_URL,
        method: "GET",
        params: {
          ...params,
        },
      })
        .then((res) => {
          const orgMembersTransformed = res.data
            .map((x) => {
              return {
                ...x,
                role: convertToTitleCase(
                  x.role_name.replace("org", "").replace("project", "").trim()
                ),
                role_id: x.role_id,
                created_at: convertDate(x.created_at),
                created_at_unconverted: x.created_at,
                member_id: x.member_id,
                status: x.status,
              };
            })
            .sort(
              (a, b) =>
                new Date(b.created_at_unconverted) -
                new Date(a.created_at_unconverted)
            );
          commit("STORE_MEMBERS_SUCCESS", orgMembersTransformed);
          resolve(orgMembersTransformed);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  fetchRoles({ commit }) {
    return new Promise((resolve, reject) => {
      apiRequest({
        url: GET_ROLES_URL,
        method: "GET",
        params: { type: "o" },
      })
        .then((response) => {
          const roles = response.data.map((x) => {
            return {
              id: x.Id,
              name: convertToTitleCase(x.Name),
            };
          });
          commit("STORE_ROLES_SUCCESS", roles);
          resolve(roles);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  selectMember({ commit }, member) {
    commit("SELECT_MEMBER", member);
    commit("SHOW_MEMBER_MODAL", true);
  },

  setShowMemberModal({ commit }, show) {
    if (!show) {
      commit("SELECT_MEMBER", null);
    }
    commit("SHOW_MEMBER_MODAL", show);
  },

  deleteMember({ commit }, memberId) {
    commit("DELETE_MEMBER", memberId);
  },
};

function convertToTitleCase(str) {
  if (!str) return "";
  return str[0].toUpperCase() + str.slice(1);
}
